<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<div class="btn-group pull-right">
					<button @click="$refs.create.open()" class="btn btn-default">
						<i class="fa fa-plus" aria-hidden="true"></i>
					</button>
				</div>
			</div>
		</div>

		<template v-if="alerts">
			<template v-if="alerts.length">
				<div class="row">
					<div class="col-md-12">
						<div class="table-responsive">
							<table class="table table-hover table-striped table-condensed">
								<thead>
									<tr>
										<th>Nombre</th>
										<th>Tipo</th>
										<th>Mínimo</th>
										<th>Máximo</th>
										<th>Autor</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="alert in alerts">
										<td>{{ alert.name }}</td>
										<td>
											<template v-if="alert.type">
												<template v-if="alert.type.lang">
													{{ alert.type.lang.name }}
												</template>
												<template v-else>
													{{ alert.type.name }}
												</template>
											</template>
										</td>
										<td>{{ alert.min }}</td>
										<td>{{ alert.max }}</td>
										<td>
											<template v-if="alert.author">
												{{ alert.author.email }}
											</template>
										</td>
										<td>
											<div class="btn-group pull-right">
												<button @click="$refs.edit.open(alert)" type="button" class="btn btn-default">
													<i class="fa fa-pencil-square-o" aria-hidden="true"></i>
												</button>
												<button @click="destroy(alert)" type="button" class="btn btn-danger">
													<i class="fa fa-trash" aria-hidden="true"></i>
												</button>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</template>
		</template>

		<create
			@reload="reload"
			ref="create"
			:user="user"
			:isAuth="isAuth"
			:product="product">
		</create>

		<edit
			@reload="reload"
			ref="edit"
			:user="user"
			:isAuth="isAuth"
			:product="product">
		</edit>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Create from './../views/Create'
	import Edit from './../views/Edit'

	export default {
		props: ['user', 'isAuth', 'product'],
		components: {
			'create': Create,
			'edit': Edit,
		},
		data () {
			return {
				alerts: null,
				types: null,
			}
		},
		created() {
			this.init();
		},
		methods: {
			init() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/management/products/' + this.product.id + '/alerts')
					.then(response => {
						this.alerts = response.body
					})
			},
			reload() {
				this.getData()
			},
			destroy (alert) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/management/products/alerts/' + alert.id)
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/products/components/alerts/layout/Alerts.vue